import { FC } from "react";

import { getOrganizationAssistantGateState } from "./helpers/getOrganizationAssistantGateState";
import { useOrganizationSupportChannel } from "./helpers/useOrganizationSupportChannel";
import { usePublishOrganizationSupportChannel } from "./helpers/usePublishOrganizationSupportChannel";
import { OrganizationAssistantWidget } from "./OrganizationAssistantWidget";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { RouteType } from "@/common/hooks/amplitude/useLogRouteChangePageVisits";
import { useSuppressChatWidget } from "@/common/hooks/useChatWidgetSuppression";
import { useZeffyLauncherSuppressed } from "@/common/hooks/useZeffyLauncherSuppression";
import { useChatWidgetRoute } from "@/components/ChatWidgetVisibilityManager/helpers/useChatWidgetRoute";
import { useLogAssistantWidgetEvents } from "@/features/Assistant/Widget/helpers/useLogAssistantWidgetEvents";

export const OrganizationAssistantWidgetGate: FC = () => {
  const { organization } = useCurrentUserContext();
  const { isClientReady, pathWithoutLocale, isHiddenByRoute } = useChatWidgetRoute();
  const resolution = useOrganizationSupportChannel(pathWithoutLocale);
  const state = getOrganizationAssistantGateState({
    channel: resolution.channel,
    routeType: resolution.routeType,
    isClientReady,
    isHiddenByRoute,
  });
  const isLauncherSuppressed = useZeffyLauncherSuppressed();
  const events = useLogAssistantWidgetEvents({
    feature: "organization-assistant",
    routeType: RouteType.OrganizationRoute,
    path: pathWithoutLocale,
  });

  usePublishOrganizationSupportChannel({ resolution, path: pathWithoutLocale, enabled: state.publish });
  useSuppressChatWidget(state.suppressForethought);

  if (!state.showWidget || !organization) {
    return null;
  }

  return <OrganizationAssistantWidget key={organization.id} hidden={isLauncherSuppressed} {...events} />;
};
